import { push } from 'connected-react-router';

import { login } from 'common/api/v1/auth';
import {
    getRuntimeLanguage,
    initProfileConfigurationActions,
} from 'common/utils/helpers/multiregion';
import { initSessionActions } from 'common/utils/helpers/session';

import setCurrentValues from '../../profile/actions/setCurrentValues';
import setTheme from '../../profile/actions/setTheme';
import updateConfiguration from '../../profileConfiguration/actions/updateConfiguration';
import {
    LOGIN_USER,
    LOGIN_USER_FAILURE,
    LOGIN_USER_SUCCESS,
} from '../actionTypes';
import { loginActions } from '../reducer';

export default (data, onSuccessCallback) => (dispatch) => {
    dispatch(loginActions[LOGIN_USER]());

    login(data)
        .then((response) => {
            const data = response?.data;
            const { token, ...rest } = data;

            localStorage.setItem('token', token);
            localStorage.setItem('session', JSON.stringify(rest));

            if (onSuccessCallback)
                onSuccessCallback(
                    rest.settings
                        ? rest.settings?.language?.key
                        : getRuntimeLanguage(),
                );

            dispatch(loginActions[LOGIN_USER_SUCCESS]());

            initSessionActions((data) => dispatch(setCurrentValues(data)));
            initProfileConfigurationActions((data) =>
                dispatch(updateConfiguration(data)),
            );

            if (rest.settings !== null) {
                if (rest.settings?.mode)
                    dispatch(setTheme(rest.settings.mode.toLowerCase()));

                localStorage.setItem(
                    'selectedDrawerSize',
                    rest.settings.expanded_sidebar ? 'normal' : 'small',
                );
            }

            dispatch(push('/projects'));
        })
        .catch((error) =>
            dispatch(
                loginActions[LOGIN_USER_FAILURE](error?.response?.data?.errors),
            ),
        );
};
